import { render } from "./ClIcon.vue?vue&type=template&id=e0b1e1a8&scoped=true"
import script from "./ClIcon.vue?vue&type=script&lang=js"
export * from "./ClIcon.vue?vue&type=script&lang=js"

import "./ClIcon.vue?vue&type=style&index=0&id=e0b1e1a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0b1e1a8"]])

export default __exports__